/* va-vie-2026.js - 19 septembre 2026
 *
 * Deux bandes qui donnent de la vie a la page Commander sans toucher aux
 * vignettes de produits : celles-ci doivent rester a plat, cadrees pareil, fond
 * blanc, parce que c'est ce qui permet l'apercu du logo du client.
 *
 *   1. BANDE CLIENTS - les logos de vrais clients defilent sous la grille.
 *   2. COUVERTURE DE CATEGORIE - un bandeau photo court au-dessus de la grille,
 *      qui change selon l'onglet choisi. Vide tant qu'on n'a pas les photos :
 *      voir VA_COUV plus bas, il suffit d'y coller les URL.
 *
 * Rien n'est modifie dans l'application. Les deux bandes sont inserees dans le
 * DOM et remises en place par un MutationObserver si React les retire. Si la
 * structure change, elles ne s'affichent simplement plus.
 *
 * Retour arriere : retirer la balise script dans templates/page.commander.liquid.
 */
(function () {
  'use strict';

  var F = '/cdn/shop/files/';

  /* --- 1. LES CLIENTS ------------------------------------------------------ */
  var CLIENTS = [
    ['Municipalit\u00e9 de Saint-Anselme', 'Muni-Saint-Anselme-coul_2846d7c3-80a6-48da-a08b-ca99098aa62f.png'],
    ['Parc du Massif',                     'Parc-massif-coul.png'],
    ['Lacasse',                            'Lacasse-coul.png'],
    ['UNI',                                'Uni-coul.png'],
    ['E. Turgeon Sport',                   'E-Turgeon-Sport-coul.png'],
    ['Extr\u00eame Fab',                   'extreme-fab-coul.png'],
    ['Sports Experts',                     'Sports-experts-coul.png'],
    ['CFP',                                'CFP-coul_0876cdef-2a96-4638-a3f3-d6b69f8d8fa0.png'],
    ['9999',                               '9999-detoure.png']
  ];

  /* --- 2. LES COUVERTURES DE CATEGORIE ------------------------------------- */
  /* Colle ici l'URL d'une photo par onglet. Format ideal : 2000 x 600 environ,
     le sujet au centre. Un onglet sans photo n'affiche aucun bandeau - c'est
     voulu, mieux vaut rien qu'une image generee. */
  var VA_COUV = {
    'Tout':                 '',
    'Pack Combos':          '',
    'T-shirts':             '',
    'Hoodies et crewnecks': '',
    'Polos':                '',
    'Casquettes':           '',
    'Tuques':               ''
  };

  var CSS = [
    '.va-bande{margin-left:calc(50% - 50vw);margin-right:calc(50% - 50vw);padding-left:calc(50vw - 50%);padding-right:calc(50vw - 50%)}',
    '.va-clients{margin-top:56px;padding-top:34px;padding-bottom:34px;border-top:1px solid rgba(17,18,20,.08);border-bottom:1px solid rgba(17,18,20,.08)}',
    '.va-clients-titre{margin:0 0 20px;font-size:11px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:rgba(17,18,20,.45)}',
    '.va-piste-cadre{overflow:hidden;position:relative;-webkit-mask-image:linear-gradient(90deg,transparent,#000 6%,#000 94%,transparent);mask-image:linear-gradient(90deg,transparent,#000 6%,#000 94%,transparent)}',
    '.va-piste{display:flex;align-items:center;gap:56px;width:max-content;animation:va-defile 42s linear infinite}',
    '.va-piste-cadre:hover .va-piste{animation-play-state:paused}',
    '.va-piste img{height:52px;width:auto;max-width:150px;object-fit:contain;filter:grayscale(1);opacity:.55;transition:filter .25s ease,opacity .25s ease}',
    '.va-piste img:hover{filter:grayscale(0);opacity:1}',
    '@keyframes va-defile{from{transform:translate3d(0,0,0)}to{transform:translate3d(-50%,0,0)}}',
    '@media(max-width:640px){.va-clients{margin-top:40px;padding-top:26px;padding-bottom:26px}.va-piste{gap:38px}.va-piste img{height:40px;max-width:112px}}',
    '@media(prefers-reduced-motion:reduce){.va-piste{animation:none}.va-piste-cadre{overflow-x:auto}}',
    '.va-couv{position:relative;height:172px;margin-top:22px;overflow:hidden;background-size:cover;background-position:center 45%;background-repeat:no-repeat}',
    '.va-couv::after{content:"";position:absolute;inset:0;background:linear-gradient(90deg,rgba(6,9,16,.62),rgba(6,9,16,.18) 55%,rgba(6,9,16,0))}',
    '.va-couv span{position:absolute;left:calc(50vw - 50%);bottom:20px;z-index:1;color:#fff;font-weight:800;font-size:22px;letter-spacing:-.01em;text-shadow:0 1px 18px rgba(0,0,0,.4)}',
    '@media(max-width:640px){.va-couv{height:118px}.va-couv span{font-size:17px;bottom:14px}}'
  ].join('\n');

  function style() {
    if (document.getElementById('va-vie-css')) { return; }
    var s = document.createElement('style');
    s.id = 'va-vie-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function bandeClients() {
    var d = document.createElement('div');
    d.className = 'va-bande va-clients';
    d.id = 'va-clients';
    var h = document.createElement('p');
    h.className = 'va-clients-titre';
    h.textContent = 'Ils portent nos v\u00eatements';
    var cadre = document.createElement('div');
    cadre.className = 'va-piste-cadre';
    var piste = document.createElement('div');
    piste.className = 'va-piste';
    for (var tour = 0; tour < 2; tour++) {
      for (var i = 0; i < CLIENTS.length; i++) {
        var im = document.createElement('img');
        im.src = F + CLIENTS[i][1] + '?width=300';
        im.alt = tour === 0 ? CLIENTS[i][0] : '';
        im.loading = 'lazy';
        im.setAttribute('aria-hidden', tour === 0 ? 'false' : 'true');
        piste.appendChild(im);
      }
    }
    cadre.appendChild(piste);
    d.appendChild(h);
    d.appendChild(cadre);
    return d;
  }

  function bandeCouv() {
    var d = document.createElement('div');
    d.className = 'va-bande va-couv';
    d.id = 'va-couv';
    d.appendChild(document.createElement('span'));
    d.style.display = 'none';
    return d;
  }

  var ongletCourant = 'Tout';

  function majCouv() {
    var d = document.getElementById('va-couv');
    if (!d) { return; }
    var u = VA_COUV[ongletCourant] || '';
    if (!u) { d.style.display = 'none'; return; }
    d.style.display = '';
    d.style.backgroundImage = 'url("' + u + '")';
    d.firstChild.textContent = ongletCourant === 'Tout' ? '' : ongletCourant;
  }

  function place() {
    var sticky = document.querySelector('#vision-root main div.sticky');
    if (!sticky || !sticky.parentElement) { return false; }
    var sec = sticky.parentElement;

    if (!document.getElementById('va-couv')) {
      sec.insertBefore(bandeCouv(), sticky.nextSibling);
      majCouv();
    }

    /* La bande va juste sous la grille de produits. On s'ancre sur la grille
       elle-meme et non sur le bloc d'avis : celui-ci arrive parfois plus tard,
       et la bande se retrouvait alors tout en bas. Si elle derive, on la remet. */
    var grille = sec.querySelector(':scope > div.grid');
    var bande = document.getElementById('va-clients');
    if (!bande) {
      bande = bandeClients();
      if (grille) { sec.insertBefore(bande, grille.nextSibling); }
      else { sec.appendChild(bande); }
    } else if (grille && bande.previousElementSibling !== grille) {
      sec.insertBefore(bande, grille.nextSibling);
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('#vision-root main div.sticky button') : null;
    if (!b) { return; }
    ongletCourant = (b.textContent || '').trim();
    setTimeout(majCouv, 30);
  }, true);

  function demarre() {
    style();
    var essais = 0;
    var t = setInterval(function () {
      essais++;
      if (place() || essais > 60) { clearInterval(t); }
    }, 400);
    var root = document.getElementById('vision-root');
    if (root && window.MutationObserver) {
      var mo = new MutationObserver(function () {
        place();
      });
      mo.observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarre);
  } else {
    demarre();
  }
})();
